import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserPractice } from "../../../modules/user-management/types/user-management.types";
import { areArraysEqual } from "../../../utils/helpers";
import {
    getPracticeSession,
    setPracticeSession,
} from "../../../utils/practiceSessionStore";

export interface PracticeState {
    practice: UserPractice | null;
}

interface ChangePracticeProps {
    practice: UserPractice | null;
    updateLocation: boolean;
}

const { practice: initialPractice } = getPracticeSession();

const initialState: PracticeState = {
    practice: initialPractice,
};

export const practiceSlice = createSlice({
    name: "userPractice",
    initialState,
    reducers: {
        handleChangePractice: (
            state,
            action: PayloadAction<ChangePracticeProps>
        ) => {
            const { practice, updateLocation } = action.payload;
            if (practice) {
                if (
                    state.practice?.practice_id === practice.practice_id &&
                    state.practice?.user_id === practice.user_id &&
                    areArraysEqual(state.practice?.roles, practice.roles) &&
                    areArraysEqual(
                        state.practice?.permissions,
                        practice.permissions
                    )
                ) {
                    return;
                }
                state.practice = practice;
                setPracticeSession(practice);
            } else {
                state.practice = practice;
            }

            if (updateLocation) {
                window.location.href = "/";
            }
        },
        handleClearPractice: (state) => {
            state.practice = null;
        },
    },
});

export const { handleChangePractice, handleClearPractice } =
    practiceSlice.actions;

export default practiceSlice.reducer;
